// @flow
import { countries } from 'country-data';

const ofacCountries = [
  'Belarus',
  'Burma',
  'Central African Republic',
  "Côte d'Ivoire",
  'Cuba',
  'Democratic Republic Of Congo',
  'Iran',
  'Iran, Islamic Republic Of',
  'Iraq',
  "Korea, Democratic People's Republic Of",
  'Lebanon',
  'Libya',
  'South Sudan',
  'Somalia',
  'Sudan',
  'Syria',
  'Yemen',
  'Yemen, Democratic',
  'Ukraine',
  'Venezuela',
  'Zimbabwe'
];

//Remove OFAC countries from country list
//country-date package has United Kingdom twice, fixed bug by deleting one with alpha 2 = UK
export const acceptableCountryOptions = countries.all
  .filter(c => !ofacCountries.includes(c.name) && c.alpha2 !== 'UK')
  .map(country => ({ text: country.name, value: country.alpha2 }));

//sort acceptable countries by country name
export const countryOptions = acceptableCountryOptions.sort(function(a, b) {
  if (a.text > b.text) {
    return 1;
  }
  if (a.text < b.text) {
    return -1;
  }
  return 0;
});

countryOptions.unshift({
  text: '',
  value: ''
});

export const getCountryName = (countryCode: string) =>
  (countries[countryCode] || {}).name;
